/**
 * 화면에 모달(.modal-area 배경)이 떠 있는 동안 뒤 페이지(문서) 스크롤 잠금.
 * 모달 배경이 고정 위치라 휠·터치 스크롤이 문서로 넘어가 뒤 목록이 움직이던 문제 → html 스크롤을 막고,
 * 스크롤바가 사라지며 화면이 옆으로 밀리지 않게 그 폭만큼 오른쪽 여백을 줌. 모달 안 스크롤은 그대로 동작.
 * 모든 모달에 일괄 적용 (DOM 변화를 지켜보다 .modal-area 가 하나라도 보이면 잠금, 모두 닫히면 해제)
 */
let locked = false;
let scheduled = false;

function hasOpenModal() {
    const list = document.querySelectorAll('.modal-area');
    for (let i = 0; i < list.length; i++) {
        if (list[i].getClientRects().length > 0) return true;   //v-show 등으로 숨긴 것은 제외
    }
    return false;
}

function sync() {
    scheduled = false;
    const open = hasOpenModal();
    if (open === locked) return;
    const html = document.documentElement;
    if (open) {
        const scrollbar = window.innerWidth - html.clientWidth;
        html.style.overflow = 'hidden';
        if (scrollbar > 0) html.style.paddingRight = scrollbar + 'px';
    } else {
        html.style.overflow = '';
        html.style.paddingRight = '';
    }
    locked = open;
}

export function installModalScrollLock() {
    if (typeof MutationObserver === 'undefined') return;
    const observer = new MutationObserver(() => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(sync);
    });
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
    sync();
}
